import "./Info.css"
const Info = props => <span className={"info " + props.type}> {props.message}</span>
export default Info